// Ported from nenda-autoplayer's src/components/Playback/Overlays/LogoOverlay.tsx.
// RN `View`/`Image` -> plain DOM `<img>`. One simplification: upstream tracks
// aspect ratio itself via `Image.getSize`'s async callback (an RN-only API with
// no DOM equivalent) and applies it as an explicit `aspectRatio` style. A plain
// `<img>` with `height` fixed and `width: "auto"` gets the same visual result
// from the browser's own intrinsic sizing, with no extra state/effect needed.
import React from "react";
import { OverlayPosition } from "../types/Schedule";

interface LogoOverlayProps {
  src: string;
  position?: OverlayPosition;
  height?: number;
}

const getOverlayPositionStyle = (
  position: OverlayPosition
): React.CSSProperties => {
  switch (position) {
    case OverlayPosition.TOP_LEFT:
      return { top: 35, left: 35 };
    case OverlayPosition.TOP_RIGHT:
      return { top: 35, right: 35 };
    case OverlayPosition.BOTTOM_LEFT:
      return { bottom: 35, left: 35 };
    case OverlayPosition.BOTTOM_RIGHT:
      return { bottom: 35, right: 35 };
    default:
      return { top: 35, left: 35 };
  }
};

const LogoOverlay: React.FC<LogoOverlayProps> = ({
  src,
  position = OverlayPosition.TOP_LEFT,
  height = 250,
}) => {
  return (
    <div
      data-testid="signage-logo-overlay"
      style={{
        position: "absolute",
        zIndex: 200,
        ...getOverlayPositionStyle(position),
      }}
    >
      <img
        src={src}
        alt=""
        style={{ height, width: "auto", objectFit: "contain" }}
        onError={(e) =>
          console.error("[signage-engine] LogoOverlay failed to load:", e)
        }
      />
    </div>
  );
};

export default LogoOverlay;
